<div [formGroup]="detailsFormGroup">
  <div class="row">
    <div class="form-group col col-ms-6 col-xs-6">
      <h5>{{ cardTitle }}</h5>
      <label class="control-label" for="address1">Address 1</label>
      <input id="address1" formControlName="address1" title="address 1" type="text" maxlength="51"
        class="form-control col-sm-6" placeholder="Address 1" aria-required="true" autocomplete="off" />
    </div>
  </div>
  <div class="row">
    <div class="form-group col col-ms-6 col-xs-6">
      <label class="control-label" for="address2">Address 2</label>
      <input id="address2" formControlName="address2" title="address 2" type="text" maxlength="51"
        class="form-control col-sm-6" placeholder="Address 2" aria-required="true" autocomplete="off" />
    </div>
  </div>
  <div class="row">
    <div class="form-group col col-ms-6 col-xs-6">
      <label class="control-label" for="suburb">Suburb/City</label>
      <input id="suburb" formControlName="suburb" title="suburb" type="text" maxlength="50"
        class="form-control col-sm-6" placeholder="Suburb" aria-required="true" autocomplete="off" />
    </div>
  </div>
  <div class="row">
    <div class="form-group col col-ms-6 col-xs-6">
      <label class="control-label" for="state">State/Territory</label>
      <select id="state" formControlName="state" class="form-control col-sm-6">
        <option value="" selected>Select state</option>
        <option value="act">Australian Capital Territory</option>
        <option value="nsw">New South Wales</option>
        <option value="nt">Northern Territory</option>
        <option value="sa">South Australia</option>
        <option value="tas">Tasmania</option>
        <option value="qld">Queensland</option>
        <option value="vic">Victoria</option>
        <option value="wa">Western Australia</option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="form-group col col-ms-6 col-xs-6">
      <label class="control-label" for="postCode">Postcode</label>
      <input id="postCode" formControlName="postCode" title="postcode" type="text" maxlength="6"
        class="form-control col-sm-6" placeholder="postcode" aria-required="true" autocomplete="off" />
    </div>
  </div>
  <div class="row">
    <div class="form-group col col-ms-6 col-xs-6">
      <label class="control-label" for="country">Country</label>
      <select id="country" formControlName="country" class="form-control col-sm-6">
        <option value="">Select Country</option>
        <option value="AUS" selected>Australia</option>
      </select>
    </div>
  </div>
</div>
